import { render, staticRenderFns } from "./charts.vue?vue&type=template&id=85f2ef52&scoped=true&"
import script from "./charts.vue?vue&type=script&lang=js&"
export * from "./charts.vue?vue&type=script&lang=js&"
import style0 from "./charts.vue?vue&type=style&index=0&id=85f2ef52&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f2ef52",
  null
  
)

export default component.exports